import {HttpClient} from "@angular/common/http";
import {inject, Service} from "@angular/core";
import type {IJsonObject} from "dcerialize";
import {Deserialize} from "dcerialize";
import type {Observable} from "rxjs";
import {map} from "rxjs";
import type {IPaginated, IPaginationQuery} from "../../models/IPaginated";
import type {FeaturedReference, Reference} from "../../models/Reference/Reference";
import {References} from "../../models/Reference/References";
import {BaseApi} from "./base-api";

@Service()
export class ReferencesApi extends BaseApi {
  private readonly http = inject(HttpClient);

  public constructor() {
    super("references");
  }

  public getAllReferences(paginationQuery?: IPaginationQuery): Observable<IPaginated<Reference>> {
    const params = this.httpParamsFromPaginationQuery(paginationQuery);
    return this.http.get<IJsonObject>(this.getEndpointUrl(), params ? {params} : undefined)
      // eslint-disable-next-line new-cap
      .pipe(map(json => Deserialize(json, () => References<Reference>)));
  }

  public getFeaturedReferences(paginationQuery?: IPaginationQuery): Observable<IPaginated<FeaturedReference>> {
    const params = this.httpParamsFromPaginationQuery(paginationQuery);
    return this.http.get<IJsonObject>(this.getEndpointUrl("featured"), params ? {params} : undefined)
      // eslint-disable-next-line new-cap
      .pipe(map(json => Deserialize(json, () => References<FeaturedReference>)));
  }
}
